import includes from "lodash/includes";
import styled from "styled-components";
export const SIZES = {
    TAB_HEIGHT: 44,
    MAX_TAB_CONTENT_WIDTH: 250,
    NAVIGATION_PANEL_HEIGHT: 44,
    NAVIGATION_PANEL_ITEMS_HEIGHT: 26,
    DOCUMENT_TYPE_SWITCHER_WIDTH: 330
};
export default {
    TabItem: styled.div
        .withConfig({
        shouldForwardProp: (prop) => !includes(["active"], prop)
    })
        .attrs({
        className: "caption-with-actions-panel v-center-items position-relative"
    }) `
    && {
      grid-column-gap: 0.5em;
    }
    width: max-content;
    height: ${SIZES.TAB_HEIGHT - 16}px;
    > :first-child {
      max-width: ${SIZES.MAX_TAB_CONTENT_WIDTH}px;
    }

      padding: 6px 8px 6px 12px;
      border: ${({ theme }) => theme["tab-item-border"]};
      background-color: ${({ theme }) => theme["tab-item-bg"]};
      border-radius:  ${({ theme }) => theme["border-radius-medium"]};
      color: ${({ theme }) => theme["gray-400"]};
      
      ${({ active }) => active &&
        `background-color: #DFE5EC;
       overflow: hidden;
       border-radius: 8px;
       color: #112232;
       `}
  `,
    TabAddBtn: styled.div.attrs({
        className: "d-grid v-center-items"
    }) `
    height: ${SIZES.TAB_HEIGHT - 16}px;
    line-height: ${SIZES.TAB_HEIGHT - 16}px;
    width: ${SIZES.TAB_HEIGHT}px;
    background: transparent;
    > i {
      height: ${SIZES.TAB_HEIGHT - 16}px;
      width: ${SIZES.TAB_HEIGHT}px;
    }
  `,
    Navigation: styled.div `
    display: grid;
    gap: 1em;
    grid-template-columns: 1fr ${SIZES.DOCUMENT_TYPE_SWITCHER_WIDTH}px 1fr;
    align-content: center;
    height: ${SIZES.NAVIGATION_PANEL_HEIGHT}px;
  `
};
